exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:500px){.modal{padding:0 5px}.modal-content{padding:8px;margin-top:30px}.surveyModal .modal-content{padding:30px 0}.el-col-xs-12{width:100%}.stepper__wrapper{height:100%!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a4523098","scoped":false,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/main-survey/survey.vue
// module id = 863
// module chunks = 0